import { zod4Resolver } from 'mantine-form-zod-resolver'
import { useSupplierForm } from '../hook/supplier-form'
import { useForm } from '@mantine/form'
import { supplierValidation, clientSupplierValidation } from './validation'

export const useFormSupplier = () => {
  return useSupplierForm({
    mode: 'controlled',
    validate: zod4Resolver(supplierValidation()),
    cascadeUpdates: true,
    initialValues: {
      name: '',
      total_product: 0,
      address: '',
      website: '',
      users: [],
      country_id: null,
      province_id: null,
      city_id: null,
      district_id: null,
      settings: [],
      acronim_name: '',
      invitation_code: '',
      featured: false,
      active: false,
      group_link: '',
      biography: '',
      refund_policy: '',
      warranty_policy: '',
      purchase_note: '',
      currency: 'IDR',
      minimum_order: 0,
      pic_name: '',
      pic_email: '',
      pic_phone: '',
      slug: '',
      is_enable_discount: false,
      discount_minimum_spend: 0,
      discount_type: 'percentage',
      discount_amount: 0,
      discount_cities: [],
      logo_encoded: null
    },
    transformValues: (values) => {
      const detailPIC = [
        {
          label: 'name',
          value: values.pic_name,
        },
        {
          label: 'phone',
          value: values.pic_phone,
        },
        {
          label: 'email',
          value: values.pic_email,
        },
      ]

      const settingSupplier = [
        {
          key: 'min_order_value',
          value: values.minimum_order,
        },
        {
          key: 'min_order_currency',
          value: values.currency,
        },
      ]

      let dataUser = []
      const userData = values.users
      if (userData.length > 0) {
        const remapData = userData.map((val) => {
          return {
            id: val.id,
            type: val.type
          }
        })
        dataUser = remapData
      }
      const payload = {
        name: values.name,
        country_id: Number(values.country_id),
        province_id: values.province_id ? Number(values.province_id) : null,
        city_id: values.city_id ? Number(values.city_id) : null,
        district_id: values.district_id ? Number(values.district_id) : 0,
        address: values.address,
        website: values.website,
        settings: JSON.stringify(settingSupplier),
        pic_details: JSON.stringify(detailPIC),
        users: JSON.stringify(dataUser),
        acronim_name: values.acronim_name,
        invitation_code: values.invitation_code,
        featured: values.featured,
        active: values.active,
        group_link: values.group_link,
        biography: values.biography,
        refund_policy: values.refund_policy,
        warranty_policy: values.warranty_policy,
        purchase_note: values.purchase_note,
        slug: values.slug,
        is_enable_discount: values.is_enable_discount,
        discount_minimum_spend: values.is_enable_discount ? Number(values.discount_minimum_spend) : 0,
        discount_type: values.discount_type,
        discount_amount: values.is_enable_discount ? Number(values.discount_amount) : 0,
        logo_encoded: values.logo_encoded
      }
      if (values.is_enable_discount) {
        payload.discount_cities = values.discount_cities
      }

      return payload
    }
  })
}

export const useFormClientSupplier = () => {
  return useForm({
    mode: 'controlled',
    validate: zod4Resolver(clientSupplierValidation()),
    initialValues: {
      id: '',
      type: 'admin'
    }
  })
}